import axios from "axios";
import { API_URL, AUTHENTICATION_TOKEN_ENDPOINT, AUTH_TOKEN_NAME, OAUTH_CLIENT_ID, OAUTH_CLIENT_SECRET } from "../config";


const authData = JSON.parse(localStorage.getItem(AUTH_TOKEN_NAME));

// give 5 minute time out
const axiosInstance = axios.create({
  baseURL: API_URL,// + '/api',
  timeout: 300000,
  headers: {
    'Authorization': `Bearer ${authData?.access_token}`,
    'Content-Type': 'application/json',
    'accept': 'application/json'
  }
});

const applyAuthTokens = (tokenPayload) => {
  if (!tokenPayload?.access_token) {
    return false;
  }
  localStorage.setItem(AUTH_TOKEN_NAME, JSON.stringify(tokenPayload));
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${tokenPayload.access_token}`;
  if (tokenPayload.id_token) {
    axiosInstance.defaults.headers.common['X-ID-Token'] = tokenPayload.id_token;
  } else {
    delete axiosInstance.defaults.headers.common['X-ID-Token'];
  }
  return true;
};

let refreshPromise = null;


export function setDefaultHeader(key, value) {
  axiosInstance.defaults.headers.common[key] = value;
}

// Request interceptor for API calls where we inject the authorization token into each call
axiosInstance.interceptors.request.use(
  async (config) => {
    const authData = JSON.parse(localStorage.getItem(AUTH_TOKEN_NAME));
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${authData?.access_token}`;
    if (authData?.id_token) {
      config.headers['X-ID-Token'] = authData.id_token;
    } else {
      delete config.headers['X-ID-Token'];
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(function (response) {

  return response;
}, function (error) {
  const originalRequest = error.config;  
  // Prevent infinite loops
  if (!error.response || error.response.status === 500) {
    console.error("RESPONSE NOT AVAILABLE. POSSIBLE SERVER CONNECTION ISSUE ", error)
    return Promise.reject(error);
  }

// if we get a 401 (UNAUTHORIED) and we're calling for a TOKEN, then return to sign in
  if (error.response?.status === 401 && originalRequest.url === AUTHENTICATION_TOKEN_ENDPOINT ) {    
    window.location.href = '/';
    return Promise.reject(error);
  }
  
  // Check if we have a 401 (unauthorized)
  if (error.response?.status === 401) {
    const authData = JSON.parse(localStorage.getItem(AUTH_TOKEN_NAME));    
    const refreshToken = authData?.refresh_token;

    if (originalRequest._retry) {
      localStorage.removeItem(AUTH_TOKEN_NAME);
      window.location.href = '/';
      return Promise.reject(error);
    }
    originalRequest._retry = true;

    // do we have a refresh token available in our local storage?
    if (refreshToken) {
      const url = AUTHENTICATION_TOKEN_ENDPOINT;
      const params = new URLSearchParams({
        refresh_token: refreshToken,
        grant_type: "refresh_token",
      }).toString();
      // attempt to refresh the token against the Auth server
      if (!refreshPromise) {
        refreshPromise = axios.post(url, params, {
          auth: {
            username: OAUTH_CLIENT_ID,
            password: OAUTH_CLIENT_SECRET
          },
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "accept": "application/json"
          }
        }).finally(() => {
          refreshPromise = null;
        });
      }
      return refreshPromise
        .then((response) => {
          // if ok, store the new token and retry the original request
          if (applyAuthTokens(response?.data)) {
            originalRequest.headers['Authorization'] = `Bearer ${response.data.access_token}`;
            if (response.data.id_token) {
              originalRequest.headers['X-ID-Token'] = response.data.id_token;
            }
            return axiosInstance(originalRequest);
          }
          localStorage.removeItem(AUTH_TOKEN_NAME);
          window.location.href = '/logout';
          return Promise.reject(error);
        })
        .catch(err => {
          console.warn("COULD NOT REFRESH RETURNING TO LOGIN", err)
          localStorage.removeItem(AUTH_TOKEN_NAME)
          window.location.href = '/';
          return Promise.reject(err);
        });

    } else {
      console.warn("Refresh token not available.")
      localStorage.removeItem(AUTH_TOKEN_NAME)
      window.location.href = '/';
    }
  }
  // specific error handling done elsewhere
  return Promise.reject(error);
}
);

export default axiosInstance;

